import { ClientGroupSourceUpdate } from 'api';

export const clientGroupSourceUpdateResponse = (values: ClientGroupSourceUpdate) => ({
  clientGroupSourceUpdate: {
    ...values,
    __typename: 'ClientGroupSource',
  },
});
